import { EntityMetadataMap, DefaultDataServiceConfig } from '@ngrx/data';
import {EnvConfigurationService} from '@core/services/env-configuration.service';

const entityMetadata: EntityMetadataMap = {
    SafetyRecommendation: {
      selectId: entity => entity.e2id,
    },
    SafetyRecommendationDetail: {
      selectId: entity => entity.e2Id,
    },
    TaxonomyVersionSimple: {},
    TaxonomyAttributeValuesData: {},
    TaxonomyAttribute: {}
};

export const entityConfig = {
    entityMetadata
};

export function defaultDataServiceConfig(configService: EnvConfigurationService): DefaultDataServiceConfig {
  return {
    root: configService.env.baseUrl
  };
}
